/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import r from '../../../../util/Renderer'
import { NavigationDrawer, ToolbarDateNavigation } from 'ui-library/dist/external/components'
import { BaseLayout, LocalAreaLayout } from 'ui-library/dist/external/layouts'
import Dropdown from '../../../atoms/input/Dropdown'
import LocalDate from '../../../../domain/type/Date'
import ReportCheckInAction from '../../../../action/monthly_report/check_in'

export default props => {
  const date = props.match.params.date
  const target_date = date ? LocalDate.parse(date) : LocalDate.today().beginningOfMonth()
  const toolbar = { label: `宿泊者レポート`, items: props.accountMenu }

  const paginations = {
    current: {
      label: '今月',
      onClick: e => {
        const current = LocalDate.today()
          .beginningOfMonth()
          .toISODate()
        ReportCheckInAction.onMonthChanged(current, props.search.search_hotel_id)
      }
    },
    prev: {
      onClick: e => {
        const lastMonth = target_date.lastMonth().toISODate()
        ReportCheckInAction.onMonthChanged(lastMonth, props.search.search_hotel_id)
      }
    },
    next: {
      onClick: e => {
        const nextMonth = target_date.nextMonth().toISODate()
        ReportCheckInAction.onMonthChanged(nextMonth, props.search.search_hotel_id)
      }
    }
  }
  const meta = {
    component: ToolbarDateNavigation,
    data: { label: target_date.format('yyyy年MM月'), paginations: paginations }
  }

  return (
    <React.Fragment>
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <BaseLayout>
        <LocalAreaLayout
          left={
            <React.Fragment>
              <Dropdown
                name="search_hotel_id"
                value={props.search.search_hotel_id}
                options={props.option_hotels}
                isClearable={false}
                isMulti={false}
                searchable={true}
                onChange={e => ReportCheckInAction.onEdit(target_date.toISODate(), e.target.value)}
                raised
              />
            </React.Fragment>
          }
        />

        {r.renderIfOrElse(!props.search.search_hotel_id)(<p>宿泊施設を選択してください</p>)(
          <React.Fragment>
            <div style={{ width: '60%', margin: 'auto' }}>
              <h3>男女別</h3>
              <table className="report">
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>男性</th>
                    <th>女性</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>10才未満</td>
                    <td>{props.check_ins['age0m']}</td>
                    <td>{props.check_ins['age0w']}</td>
                  </tr>
                  <tr>
                    <td>10代</td>
                    <td>{props.check_ins['age10m']}</td>
                    <td>{props.check_ins['age10w']}</td>
                  </tr>
                  <tr>
                    <td>20代</td>
                    <td>{props.check_ins['age20m']}</td>
                    <td>{props.check_ins['age20w']}</td>
                  </tr>
                  <tr>
                    <td>30代</td>
                    <td>{props.check_ins['age30m']}</td>
                    <td>{props.check_ins['age30w']}</td>
                  </tr>
                  <tr>
                    <td>40代</td>
                    <td>{props.check_ins['age40m']}</td>
                    <td>{props.check_ins['age40w']}</td>
                  </tr>
                  <tr>
                    <td>50代</td>
                    <td>{props.check_ins['age50m']}</td>
                    <td>{props.check_ins['age50w']}</td>
                  </tr>
                  <tr>
                    <td>60代</td>
                    <td>{props.check_ins['age60m']}</td>
                    <td>{props.check_ins['age60w']}</td>
                  </tr>
                  <tr>
                    <td>70代以上</td>
                    <td>{props.check_ins['age70m']}</td>
                    <td>{props.check_ins['age70w']}</td>
                  </tr>
                  <tr>
                    <td>男女別計</td>
                    <td>{props.check_ins['age_total_m']}</td>
                    <td>{props.check_ins['age_total_w']}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style={{ width: '60%', margin: 'auto' }}>
              <h3>国籍別</h3>
              <table className="report">
                <tbody>
                  {props.check_ins['nations'].map((nation, index) => (
                    <tr key={`nation-${index}`}>
                      <td>{nation['label']}</td>
                      <td>{nation['count']}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ width: '60%', margin: 'auto' }}>
              <h3>職業別</h3>
              <table className="report">
                <tbody>
                  {props.check_ins['occupations'].map((occupation, index) => (
                    <tr key={`occupation-${index}`}>
                      <td>{occupation['label']}</td>
                      <td>{occupation['count']}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </React.Fragment>
        )}
      </BaseLayout>
    </React.Fragment>
  )
}
